import React from 'react';
import { Navbar } from '../components/Navbar';
import { VideoPage } from '../components/VideoPage';
import { Footer } from '../components/Footer';
export const Video = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2373" data-mp="13djvj3i7l2mz">
      <Navbar data-id="element-2374" data-mp="13bz1rg3pxnq6" />
      <VideoPage data-id="element-2375" data-mp="13b78ibxlg232" />
      <Footer data-id="element-2376" data-mp="1840d8zt2baf5" />
    </div>;
};